import { Capacitor } from "@capacitor/core";

export const trueMobile = false;

export const isMobileApp = (): boolean => {
  if (trueMobile) return true;

  const isNative = Capacitor.isNativePlatform();

  const isPWA = window.matchMedia('(display-mode: standalone)').matches || 
                (window.navigator as any).standalone || 
                document.referrer.includes('android-app://');

  return isNative || isPWA;
};
